import React from 'react'
import Collection from '../common/collection'

function CollectionU({ props }) {
  return (
    <Collection
      alt="Palmeras"
      src={[
        'https://volverse-negro-daniel.s3.amazonaws.com/images/20.+palmeras34.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/20.+palmeras35.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/20.+palmeras42.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/20.+palmeras45.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/20.+palmeras46.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/20.+palmeras48.jpg',
      ]}

    />
  )
}


export default CollectionU
